import { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { reduxForm, SubmissionError } from 'redux-form';

import { adjustBalance } from 'services/client-service';
import { Popup2, Button, themes, ButtonContainer } from 'libs/ui';
import { requiredNotZero, WhiteStyledField, ErrorMsg } from 'libs/form';
import { Content, Header, Info } from './topup-form.styled';

const TopupFormForm = (props) => {
  const { refresh, balance, close, form, handleSubmit, error } = props;
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  /**
   * make action
   * @param {*} event
   */
  const submit = (data) => {
    // console.log('🚀 ~ submit ~ data:', data, balance.client_id, balance.account_id);
    setLoading(true);
    return adjustBalance({ amount: data.amount * 100, client_id: balance.client_id })
      .then(() => {
        refresh();
      })
      .catch((error) => {
        // console.log('🚀 ~ submit ~ error:', error);
        setLoading(false);
        throw new SubmissionError({
          _error: error.toString(),
        });
      });
  };

  const valid = true;
  const requiredT = useCallback(requiredNotZero(t), [t]);
  const cl = loading ? 'loading' : '';

  return (
    <>
      <Popup2 w={480} className={cl}>
        <Content>
          <Header>{t('buttons.Корректировка баланса')}</Header>
          <form onSubmit={handleSubmit(submit)}>
            <ErrorMsg error={error} />
            <Info style={{ marginBottom: '20px' }}>
              <WhiteStyledField
                validate={requiredT}
                type="text"
                placeholder={t('form.Введите сумму')}
                label={t('form.Введите сумму')}
                name="amount"
                mask={{ suffix: t('form.руб') }}
                autoFocus
                naturalNumber
                withMinus
              />
            </Info>
            <ButtonContainer space="20px">
              <Button onClick={close} type="button">
                {t('buttons.Отменить')}
              </Button>
              <Button disabled={!valid} theme={themes.blue}>
                {t('buttons.Корректировать')}
              </Button>
            </ButtonContainer>
          </form>
        </Content>
      </Popup2>
    </>
  );
};

TopupFormForm.propTypes = {
  close: PropTypes.func.isRequired,
  refresh: PropTypes.func.isRequired,
  balance: PropTypes.any,
};

export const TopupForm = reduxForm({
  form: 'clientTopupForm',
  destroyOnUnmount: true,
})(TopupFormForm);
